import React from 'react';
import {FaIcon} from "../FaIcon";
import {EditElementModal} from "../EditElementModal";
import {EditCommentsForm} from "./EditCommentsForm";

export class EditCommentsModal extends EditElementModal {
    renderModalForm() {
        return <EditCommentsForm closeModal={this.toggle}
                                 onModified={this.handleFormSubmitted}
                                 businessUnitId={this.props.businessUnitId}
                                 campaignsConfigurationId={this.props.campaignsConfigurationId}
                                 campaignId={this.props.campaignId}
                                 adgroupId={this.props.adgroupId}
                                 comments={this.props.value}/>
    }

    renderButton() {
        return <button className="edit-button" onClick={this.toggle}><FaIcon iconName={"pencil-alt"}/></button>;
    }

    renderModalHeaderText() {
        return "Editar comentario";
    }
}
